import { render, staticRenderFns } from "./ExternalApp.vue?vue&type=template&id=0f7a14ed&scoped=true&"
import script from "./ExternalApp.vue?vue&type=script&lang=js&"
export * from "./ExternalApp.vue?vue&type=script&lang=js&"
import style0 from "./ExternalApp.vue?vue&type=style&index=0&id=0f7a14ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a14ed",
  null
  
)

export default component.exports